export { default as Table } from './Table'
export type { TableProps } from './Table'
export * as TableStyles from './Table.styles'
